const headers = {
    name: "Sites",
    navigate: {
        tabs: [
            {
                name: "Sites",
                path: "/app/inventory/sites",
            },
            {
                name: "Add",
                path: "",
            },
        ],
    },
};

export default headers;
